var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-empty"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('terminal.cart.cart.empty'))}}),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.$t('terminal.cart.cart.emptyDescription'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }